<template>
  <div class="wrap">
    <div class="box">
      <div class="revenue-header">
        <div class="seach-box">
          <span class="time">时间</span>
          <div class="select">
            <el-select v-model="seachCondition.quarter" placeholder="请选择">
              <el-option
                v-for="item in quarterList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-date-picker
              v-model="seachCondition.date"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
          <el-button type="primary" style="margin-left:10px">查询</el-button>
        </div>
      </div>
      <div class="revenue-main">
        <div class="revenue-main-show">
          <div class="show-box">
            <div class="show-box-title">当月总体情况</div>
            <div class="show-box-money">8888.00</div>
          </div>
          <div class="show-box">
            <div class="show-box-title">当月营收</div>
            <div class="show-box-money">8888.00</div>
            <div class="monrybox">
                <div>托管营收：4444.00</div>
                <div>租赁营收：4444.00</div>
            </div>
          </div>
          <div class="show-box">
            <div class="show-box-title">当月支出</div>
            <div class="show-box-money">8888.00</div>
             <div class="monrybox">
                <div>托管营收：4444.00</div>
                <div>租赁营收：4444.00</div>
            </div>
          </div>
        </div>
        <div class="revenue-chart">
          <div class="chart-box">
            <div class="chart-box-item">
              <div class="item-title">当月托管收支情况</div>
              <Echarts></Echarts>
            </div>
            <div class="chart-box-item">
              <div class="item-title">当月租赁收支情况</div>
              <Echarts></Echarts>
            </div>
          </div>
          <div class="chart-box-item">
            <div class="item-title">当月托管收支总体情况</div>
            <Echarts></Echarts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Echarts from "@/components/page/definition/echart.vue";
export default {
  data() {
    return {
      quarterList: [
        { name: "年", id: "1" },
        { name: "月", id: "2" },
        { name: "日", id: "3" }
      ],
      seachCondition: {
        quarter: "",
        date: ""
      }
    };
  },
  components: {
    Echarts
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    drawLine() {
      var app = {};
      var posList = [
        "left",
        "right",
        "top",
        "bottom",
        "inside",
        "insideTop",
        "insideLeft",
        "insideRight",
        "insideBottom",
        "insideTopLeft",
        "insideTopRight",
        "insideBottomLeft",
        "insideBottomRight"
      ];
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: posList.reduce(function(map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };
      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              },
              {
                label: labelOption
              }
            ]
          });
        }
      };
      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "",
        fontSize: 16,
        rich: {
          name: {}
        }
      };

      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["Forest", "Steppe", "Desert", "Wetland"]
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: false },
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: ["2012", "2013", "2014", "2015", "2016"]
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: "Forest",
            type: "bar",
            barGap: 0,
            label: labelOption,
            emphasis: {
              focus: "series"
            },
            data: [320, 332, 301, 334, 390]
          },
          {
            name: "Steppe",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series"
            },
            data: [220, 182, 191, 234, 290]
          },
          {
            name: "Desert",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series"
            },
            data: [150, 232, 201, 154, 190]
          },
          {
            name: "Wetland",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series"
            },
            data: [98, 77, 101, 99, 40]
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  color: #000000;
  .box {
    width: 100%;
    height: 100%;
    padding: 14px;
    border-radius: 4px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-sizing: border-box;
    .revenue-header {
      .seach-box {
        display: flex;
        align-items: center;
        text-align: left;
        .time {
          margin-right: 10px;
        }
        .select {
          margin-right: 10px;
        }
      }
    }
    .revenue-main {
      margin-top: 10px;
      .revenue-main-show {
        display: flex;
        .show-box {
          background: #eee;
          flex: 1;
          margin-left: 10px;
          padding: 10px;
          border-radius: 4px;
          .show-box-title {
            font-weight: 600;
            text-align: left;
          }
          .show-box-money {
            font-weight: 700;
            font-size: 20px;
            padding-top: 10px;
            padding-bottom: 25px;
          }
          .monrybox{
              display: flex;
              justify-content: space-between;
          }
        }
      }
      .revenue-chart {
        .chart-box {
          display: flex;
          .chart-box-item {
            padding: 10px;
            margin-top: 10px;
            margin-left: 10px;
            background: #eee;
            border-radius: 4px;
            flex: 1;
            .item-title{
                text-align: left;
                font-weight: 600;
                font-size: 16px;
                padding-bottom: 5px;
            }
          }
        }
           .chart-box-item {
            padding: 10px;
            margin-top: 10px;
            margin-left: 10px;
            background: #eee;
            border-radius: 4px;
            flex: 1;
            .item-title{
                text-align: left;
                font-weight: 600;
                font-size: 16px;
                padding-bottom: 5px;
            }
          }
      }
    }
  }
}
.pageNew {
  text-align: right;
  padding: 14px 0px 0px 0px;
}
.nc ::v-deep .el-input {
  width: 197px !important;
}
.ztWrap {
  overflow: hidden;
  white-space: normal;
}
.flexbox {
  display: flex;
}
</style>
